@if (deviceService.$isMobile()) {
<lib-bottom-sheet
  [visible]="gate.$visible()"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="true"
  [closeOnEscape]="true"
  [headerTemplate]="headerTemplate ?? headerFallbackTpl"
  [footerTemplate]="footerTemplate ?? undefined"
  (visibleChange)="onVisibleChange($event)"
  (hide)="fechar()"
>
  <ng-container *ngTemplateOutlet="conteudo"></ng-container>
</lib-bottom-sheet>
} @else {
<p-dialog
  [visible]="gate.$visible()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [showHeader]="true"
  styleClass="n-setup-operacional-dialog dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ width: 'min(96vw, 720px)', height: 'min(92dvh, 900px)' }"
  [contentStyle]="{ overflow: 'auto', flex: '1 1 auto' }"
  (visibleChange)="onVisibleChange($event)"
  (onHide)="fechar()"
>
  <ng-template pTemplate="header">
    <ng-container
      *ngTemplateOutlet="headerTemplate ?? headerFallbackTpl"
    ></ng-container>
  </ng-template>

  <ng-container *ngTemplateOutlet="conteudo"></ng-container>

  <ng-template pTemplate="footer">
    @if (footerTemplate) {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
    }
  </ng-template>
</p-dialog>
}

<ng-template #headerFallbackTpl>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-cog mr-2"></i>
            {{ 'PRIMEIRO_ACESSO.SETUP_COMPLETE_CONFIG' | translate }}
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="fechar()"
            [attr.aria-label]="'GLOBAL.FECHAR' | translate"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #conteudo>
  @if (preparando() || gate.$carregando()) {
  <div class="n-setup-loading">
    <p-progressSpinner strokeWidth="4" [ariaLabel]="'GLOBAL.CARREGANDO' | translate" />
  </div>
  } @else { @switch (activeStep()) { @case (1) {
  <lib-etapa-tipos-servico
    (headerTemplateAction)="headerTemplateAction($event)"
    (footerTemplateAction)="footerTemplateAction($event)"
    (proximaEtapa)="irParaEtapa(2)"
    (fechar)="fechar()"
  />
  } @case (2) {
  <lib-etapa-servicos
    (headerTemplateAction)="headerTemplateAction($event)"
    (footerTemplateAction)="footerTemplateAction($event)"
    (proximaEtapa)="irParaEtapa(3)"
    (etapaAnterior)="irParaEtapa(1)"
    (fechar)="fechar()"
  />
  } @case (3) {
  <lib-etapa-profissionais
    (headerTemplateAction)="headerTemplateAction($event)"
    (footerTemplateAction)="footerTemplateAction($event)"
    (proximaEtapa)="onProfissionaisConcluidos()"
    (etapaAnterior)="irParaEtapa(2)"
    (fechar)="fechar()"
  />
  } } }
</ng-template>
